import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mbm-loading',
  imports: [TranslateModule],
  templateUrl: './mbm-loading.component.html',
  styleUrl: './mbm-loading.component.scss',
})
export class MbmLoadingComponent {
  readonly messageKey = input<string | null>('general.loading');
}
